// Flags
var finlandFlag = require('ui/svg/finland-flag.svg?raw');
var germanyFlag = require('ui/svg/germany-flag.svg?raw');
var latviaFlag = require('ui/svg/latvia-flag.svg?raw');
var lithuaniaFlag = require('ui/svg/lithuania-flag.svg?raw');
var netherlandsFlag = require('ui/svg/netherlands-flag.svg?raw');
var usaFlag = require('ui/svg/usa-flag.svg?raw');
var spanishFlag = require('ui/svg/spanish-flag.svg?raw');
var polishFlag = require('ui/svg/poland-flag.svg?raw');
var frenchFlag = require('ui/svg/france-flag.svg?raw');
var denmarkFlag = require('ui/svg/denmark-flag.svg?raw');
var swedishFlag = require('ui/svg/swedish-flag.svg?raw');
var estoniaFlag = require('ui/svg/estonia-flag.svg?raw');
var norwayFlag = require('ui/svg/norway-flag.svg?raw');
export var appLanguages = [
    {
        name: 'Finnish',
        key: 'fi-FI',
        alias: 'fi',
        icon: finlandFlag,
    },
    {
        name: 'English',
        key: 'en-GB',
        alias: 'en',
        icon: usaFlag,
    },
    {
        name: 'German',
        key: 'de-DE',
        alias: 'de',
        icon: germanyFlag,
    },
];
export var publicLanguages = [
    {
        name: 'Danish',
        key: 'da-DK',
        icon: denmarkFlag,
    },
    {
        name: 'Dutch',
        key: 'nl-NL',
        icon: netherlandsFlag,
    },
    {
        name: 'English',
        key: 'en-GB',
        icon: usaFlag,
    },
    {
        name: 'Estonian',
        key: 'et-EE',
        icon: estoniaFlag,
    },
    {
        name: 'Finnish',
        key: 'fi-FI',
        icon: finlandFlag,
    },
    {
        name: 'French',
        key: 'fr-FR',
        icon: frenchFlag,
    },
    {
        name: 'German',
        key: 'de-DE',
        icon: germanyFlag,
    },
    {
        name: 'Latvian',
        key: 'lv-LV',
        icon: latviaFlag,
    },
    {
        name: 'Lithuanian',
        key: 'lt-LT',
        icon: lithuaniaFlag,
    },
    {
        name: 'Norwegian',
        key: 'no-NO',
        icon: norwayFlag,
    },
    {
        name: 'Polish',
        key: 'pl-PL',
        icon: polishFlag,
    },
    {
        name: 'Spanish',
        key: 'es-ES',
        icon: spanishFlag,
    },
    {
        name: 'Swedish',
        key: 'sv-SE',
        icon: swedishFlag,
    },
];
